import script from "./CustomDashboardModuleItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardModuleItem.vue?vue&type=script&setup=true&lang=js"

import "./CustomDashboardModuleItem.vue?vue&type=style&index=0&id=6d1e9085&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d1e9085"]])

export default __exports__